import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      <div class="search-popup">
        <button class="close-search">
          <span class="flaticon-multiply">
            <i class="fal fa-times"></i>
          </span>
        </button>
        <form method="post" action="#">
          <div class="form-group">
            <input
              type="search"
              name="search-field"
              value=""
              placeholder="Search Here"
              required=""
            />
            <button type="submit">
              <i class="fal fa-search"></i>
            </button>
          </div>
        </form>
      </div>

      <div class="it-offcanvas-area">
        <div class="itoffcanvas">
          <div class="itoffcanvas__close-btn">
            <button class="close-btn">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="itoffcanvas__logo">
            <a href="index.html">
              <img src="assets/img/logo/logo.png" alt="" />
            </a>
          </div>
          <div class="itoffcanvas__text">
            <p>
              Suspendisse interdum consectetur libero id. Fermentum leo vel orci
              porta non. Euismod viverra nibh cras pulvinar suspen.
            </p>
          </div>
          <div class="it-menu-mobile d-xl-none"></div>
          <div class="itoffcanvas__info">
            <h3 class="offcanva-title">Get In Touch</h3>
            <div class="it-info-wrapper mb-20 d-flex align-items-center">
              <div class="itoffcanvas__info-icon">
                <a href="#">
                  <i class="fal fa-envelope"></i>
                </a>
              </div>
              <div class="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div class="it-info-wrapper mb-20 d-flex align-items-center">
              <div class="itoffcanvas__info-icon">
                <a href="#">
                  <i class="fal fa-phone-alt"></i>
                </a>
              </div>
              <div class="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div class="it-info-wrapper mb-20 d-flex align-items-center">
              <div class="itoffcanvas__info-icon">
                <a href="#">
                  <i class="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div class="itoffcanvas__info-address">
                <span>Location</span>
                <a
                  href="htits://www.google.com/maps/@37.4801311,22.8928877,3z"
                  target="_blank"
                >
                  Riverside 255, San Francisco, USA{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-overlay"></div>

      <header class="it-header-height">
        <div id="header-sticky" class="it-header-area it-header-transparent">
          <div class="container">
            <div class="it-header-style-2">
              <div class="row align-items-center">
                <div class="col-xxl-2 col-xl-2 col-lg-4 col-md-5 col-6">
                  <div className="it-header-logo">
                    <a href="index.html">
                      <img
                        src="assets/img/logo/logo.png"
                        alt=""
                        width={100} // px nahi, number
                        style={{ paddingTop: 10, paddingBottom: 10 }}
                      />
                    </a>
                  </div>
                </div>
                <div class="col-xxl-6 col-xl-7 d-none d-xl-block">
                  <div class="it-header-menu it-header-dropdown">
                    <nav class="it-menu-content">
                      <ul style={{ paddingLeft: 0 }}>
                        <li class=" p-static">
                          <Link to="/">Home</Link>
                        </li>

                        <li class=" p-static">
                          <Link to="/about">About Us</Link>
                        </li>

                        <li class=" p-static">
                          <Link to="/online-class">Class Help</Link>
                        </li>

                        <li class=" p-static">
                          <Link to="/online-exams">Exams Help</Link>
                        </li>
                        <li class=" p-static">
                          <Link to="/online-assignment">Asisgnment Help</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div class="col-xxl-4 col-xl-3 col-lg-8 col-md-7 col-6">
                  <div class="it-header-right-action d-flex justify-content-end align-items-center">
                    <Link
                      to="/contact"
                      class="it-btn-yellow d-none d-xl-flex"
                    >
                      <span>
                        <span class="text-1">Get In Touch</span>
                        <span class="text-2">Get In Touch</span>
                      </span>
                      <i>
                        <svg
                          width="16"
                          height="15"
                          viewBox="0 0 16 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.0544 8.1364C15.4058 7.78492 15.4058 7.21508 15.0544 6.8636L9.3268 1.13604C8.97533 0.784567 8.40548 0.784567 8.05401 1.13604C7.70254 1.48751 7.70254 2.05736 8.05401 2.40883L13.1452 7.5L8.05401 12.5912C7.70254 12.9426 7.70254 13.5125 8.05401 13.864C8.40548 14.2154 8.97533 14.2154 9.3268 13.864L15.0544 8.1364ZM0.417969 7.5V8.4H14.418V7.5V6.6H0.417969V7.5Z"
                            fill="currentcolor"
                          />
                        </svg>
                      </i>
                    </Link>
                    <div class="it-header-bar d-xl-none">
                      <button class="it-menu-bar">
                        <span>
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 24 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M10 18.3333C10 17.4128 10.7462 16.6667 11.6667 16.6667H21.6667C22.5872 16.6667 23.3333 17.4128 23.3333 18.3333C23.3333 19.2538 22.5872 20 21.6667 20H11.6667C10.7462 20 10 19.2538 10 18.3333ZM0 1.66667C0 0.746183 0.746183 0 1.66667 0H21.6667C22.5872 0 23.3333 0.746183 23.3333 1.66667C23.3333 2.58713 22.5872 3.33333 21.6667 3.33333H1.66667C0.746183 3.33333 0 2.58713 0 1.66667ZM0 10C0 9.07953 0.746183 8.33333 1.66667 8.33333H21.6667C22.5872 8.33333 23.3333 9.07953 23.3333 10C23.3333 10.9205 22.5872 11.6667 21.6667 11.6667H1.66667C0.746183 11.6667 0 10.9205 0 10Z"
                              fill="currentcolor"
                            />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
